import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
import { TypeUtility } from 'utility-ts-type';
import { APModel, IAPProgram } from '../../models/ap_model';
import { APStudentDetailsQuery } from '../student_details/queries/student_details_query';
import { APUserModeConfig } from '../user_mode_config/config/ap_user_mode_config';
export class APDegreeTitle {
  private programTitle: string;
  private creditsTitle: string;
  private studentNk: string;
  private printDate: string;
  private program: IAPProgram;
  private studentName: string;
  private showProgramDetailsDialog = false;
  constructor(
    private ngAPModel: APModel,
    private ngAPStudentDetailsQuery: APStudentDetailsQuery,
    private accountModel: AccountModel,
    private ngAPUserModeConfig: APUserModeConfig
  ) {
    this.program = _4.head(_4.toArray(this.ngAPModel.read().program));
  }

  get __studentName() {
    const firstName = _4.get(this.ngAPStudentDetailsQuery, 'result.first_name', '');
    const lastName = _4.get(this.ngAPStudentDetailsQuery, 'result.last_name', '');
    return `${firstName} ${lastName}`;
  }

  $onChanges() {
    this.studentName = this.ngAPUserModeConfig.isAdvisor()
      ? this.__studentName
      : _4.get(this.accountModel, 'fullname', '');
    this.studentNk = this.ngAPUserModeConfig.isAdvisor()
      ? _4.get(this.ngAPStudentDetailsQuery, 'result.nk', '')
      : _4.get(this.accountModel, 'student_nk', '');
    this.programTitle = `${this.program.name} ${this.program.short_credential}`;
    this.creditsTitle = `${TypeUtility.NumberUtility.stripTrailingZeroes(this.program.credits)} Credits`;
  }
  showProgramDetails() {
    this.showProgramDetailsDialog = true;
  }
  close() {
    this.showProgramDetailsDialog = false;
  }
}

class DegreeTitleComponent implements ng.IComponentOptions {
  public controller: any;
  public templateUrl: any;
  public bindings: any;

  constructor() {
    this.controller = APDegreeTitle;
    this.bindings = {};
    this.templateUrl = 'capability-ng-academic-planner/src/global/components/degree_title/degree_title.html';
  }
}

angular.module('capability-ng-academic-planner').component('degreeTitle', new DegreeTitleComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/degree_title/degree_title.ts